'use client'
import { shouldSuggestProducts } from '@/context/GrocerContextV3/suggestedProducts'
import onCheckoutClickPath from '@/utils/onCheckoutClickPath'
import { analitycsProductParseV3 } from '@mercadoni/sinister/dist/cjs/analytics'
import { UseLoggedContext } from '@mercadoni/sinister/dist/cjs/authentication'
import { useCartContext } from '@mercadoni/sinister/dist/cjs/cart'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { useBeginCheckout } from '@mercadoni/sinister/dist/cjs/monitors'
import { useHeaderDataContext } from '@mercadoni/sinister/dist/cjs/shared/contexts'
import { useRouter } from 'next/navigation'
import { useCallback } from 'react'

interface UseCartActionsProps {
  setOpenDrawer: (open: boolean) => void
  forgotSomethingProducts: any // Replace with proper type when available
}

const useCartActions = ({
  setOpenDrawer,
  forgotSomethingProducts,
}: UseCartActionsProps) => {
  const { cart, products = {} } = useCartContext()
  const { isLogged } = UseLoggedContext()
  const router = useRouter()
  const { productSuggestion = {} } = UseClientModelContext()
  const { timeToSuggest = 120 } = productSuggestion

  const { screenNames } = useHeaderDataContext()
  const { sendBeginCheckoutEvent } = useBeginCheckout()

  const onBeginCheckout = useCallback(() => {
    const { pricesSummary = {}, id } = cart
    const { subtotal = 0 } = pricesSummary
    sendBeginCheckoutEvent({
      products: analitycsProductParseV3(Object.values(products)),
      cart_id: id || 'guest',
      value: subtotal,
      rootInfo: {
        screen_name: screenNames?.['/checkout']?.screenName,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart, products, screenNames])

  const onCheckoutClick = useCallback(() => {
    const { address = {}, operationalModel } = cart
    const path = onCheckoutClickPath({
      isLogged,
      addressId: address?.id,
      opsModel: operationalModel,
      suggestProducts: shouldSuggestProducts({
        forgotSomethingProducts,
        timeToSuggest,
      }),
    })

    if (path === '/checkout' || path === '/checkout2') {
      onBeginCheckout()
    }

    router.push(path, { scroll: false })
    setOpenDrawer(path === '/suggestedProducts2')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart, isLogged, forgotSomethingProducts, timeToSuggest, onBeginCheckout])

  return { onCheckoutClick }
}

export default useCartActions
